import DelegationListRequest, {
  DelegationListRequestDelegationType,
  DelegationListRequestState,
  DelegationListResultsOrder,
} from "../../../api/raily/delegation/list/delegation-list.request";
import paginationService from "../../../utils/pagination/pagination.service";
import DelegationListParams, {
  DelegationListParamsDelegationType,
  DelegationListParamsState,
  DelegationListParamsSortKey,
} from "./delegation-list-params";

const createOrder = (
  order: DelegationListParamsSortKey | undefined,
): DelegationListResultsOrder | undefined => {
  switch (order) {
    case DelegationListParamsSortKey.START_DATE_ASC:
      return DelegationListResultsOrder.START_DATE_ASC;
    case DelegationListParamsSortKey.START_DATE_DESC:
      return DelegationListResultsOrder.START_DATE_DESC;
    case DelegationListParamsSortKey.COST_ASC:
      return DelegationListResultsOrder.COST_ASC;
    case DelegationListParamsSortKey.COST_DESC:
      return DelegationListResultsOrder.COST_DESC;
    case DelegationListParamsSortKey.TOTAL_DISTANCE_ASC:
      return DelegationListResultsOrder.TOTAL_DISTANCE_ASC;
    case DelegationListParamsSortKey.TOTAL_DISTANCE_DESC:
      return DelegationListResultsOrder.TOTAL_DISTANCE_DESC;
    case DelegationListParamsSortKey.CREATION_DATE_ASC:
      return DelegationListResultsOrder.CREATED_DATE_ASC;
    case DelegationListParamsSortKey.CREATION_DATE_DESC:
      return DelegationListResultsOrder.CREATED_DATE_DESC;
    case DelegationListParamsSortKey.DELEGATION_NUMBER_ASC:
      return DelegationListResultsOrder.DELEGATION_NUMBER_ASC;
    case DelegationListParamsSortKey.DELEGATION_NUMBER_DESC:
      return DelegationListResultsOrder.DELEGATION_NUMBER_DESC;
    case DelegationListParamsSortKey.WORKER_NAME_ASC:
      return DelegationListResultsOrder.WORKER_NAME_ASC;
    case DelegationListParamsSortKey.WORKER_NAME_DESC:
      return DelegationListResultsOrder.WORKER_NAME_DESC;
    case DelegationListParamsSortKey.END_DATE_ASC:
      return DelegationListResultsOrder.END_DATE_ASC;
    case DelegationListParamsSortKey.END_DATE_DESC:
      return DelegationListResultsOrder.END_DATE_DESC;
    case DelegationListParamsSortKey.FIRST_CSV_DOWNLOAD_ASC:
      return DelegationListResultsOrder.FIRST_CSV_DOWNLOAD_ASC;
    case DelegationListParamsSortKey.FIRST_CSV_DOWNLOAD_DESC:
      return DelegationListResultsOrder.FIRST_CSV_DOWNLOAD_DESC;
    case DelegationListParamsSortKey.FIRST_PDF_DOWNLOAD_ASC:
      return DelegationListResultsOrder.FIRST_PDF_DOWNLOAD_ASC;
    case DelegationListParamsSortKey.FIRST_PDF_DOWNLOAD_DESC:
      return DelegationListResultsOrder.FIRST_PDF_DOWNLOAD_DESC;
    case DelegationListParamsSortKey.CARGO_COMPANY_NAME_ASC:
      return DelegationListResultsOrder.CARGO_COMPANY_NAME_ASC;
    case DelegationListParamsSortKey.CARGO_COMPANY_NAME_DESC:
      return DelegationListResultsOrder.CARGO_COMPANY_NAME_DESC;
    default:
      return undefined;
  }
};

const createType = (
  type: DelegationListParamsDelegationType | undefined,
): DelegationListRequestDelegationType | undefined => {
  switch (type) {
    case DelegationListParamsDelegationType.AUTO:
      return DelegationListRequestDelegationType.AUTO;
    case DelegationListParamsDelegationType.MANUAL:
      return DelegationListRequestDelegationType.MANUAL;
    default:
      return undefined;
  }
};

const createState = (
  state: DelegationListParamsState | undefined,
): DelegationListRequestState | undefined => {
  switch (state) {
    case DelegationListParamsState.DELETED:
      return DelegationListRequestState.DELETED;
    case DelegationListParamsState.DOWNLOADED:
      return DelegationListRequestState.DOWNLOADED;
    case DelegationListParamsState.UNDOWNLOADED:
      return DelegationListRequestState.NEW;
  }
};

const create = (params: DelegationListParams): DelegationListRequest => {
  return {
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.sortKey),
    cargoCompanyName: params.cargoCompanyName,
    startDateSince: params.startDateSince,
    startDateTo: params.startDateTo,
    endDateSince: params.endDateSince,
    endDateTo: params.endDateTo,
    creationDateSince: params.creationDateSince,
    creationDateTo: params.creationDateTo,
    firstCsvDownloadDateSince: params.firstCsvDownloadDateSince,
    firstCsvDownloadDateTo: params.firstCsvDownloadDateTo,
    firstPdfDownloadDateSince: params.firstPdfDownloadDateSince,
    firstPdfDownloadDateTo: params.firstPdfDownloadDateTo,
    workerName: params.workerName,
    delegationNumber: params.delegationNumber,
    type: createType(params.type),
    companyUuid: params.cargoCompanyUuid,
    costMax: params.costMax,
    costMin: params.costMin,
    totalDistanceMax: params.totalDistanceMax,
    totalDistanceMin: params.totalDistanceMin,
    state: createState(params.state),
  };
};

const delegationListParamsFactory = {
  create,
};

export default delegationListParamsFactory;
